export function padToTwo(hex: string) {
  return hex.padStart(2, '0');
}

export function hexToHexa(color: string, opacity: number) {
  if (color?.length === 9) return color;
  // coerce values so ti is between 0 and 1.
  const o = Math.round(Math.min(Math.max(opacity ?? 1, 0), 1) * 255);
  // pad to two hex digits to ensure valid color.
  return color + padToTwo(o.toString(16)).toUpperCase();
}

// logic derived from https://stackoverflow.com/questions/21646738/convert-hex-to-rgba
export function hexaToHex(color: string): { color: string, opacity: number } {
  const c = color.substring(1).split('');
  if (c.length !== 8) return { color, opacity: 1 };
  const o = (Math.round((parseInt(parseInt(c[6] + c[7], 16).toString(), 10) / 255) * 100) / 100);
  return {
    color: `#${c[0] + c[1] + c[2] + c[3] + c[4] + c[5]}`,
    opacity: o,
  };
}
